import { ky } from './ky';
import { AccountDto } from './account';
import { TermsAgreementDto, TermsDto } from './terms';

export interface MeResponse {
  email: string;
  activeAccount?: AccountDto;
  isRequiredTermsAgreed: boolean;
  isEmailVerified: boolean;
}

export default class AuthService {
  async me() {
    return await ky.get('v1/auth/me').json() as MeResponse;
  }

  async withdraw(reason: string) {
    return await ky.post('v1/auth/withdraw', {
      json: { reason },
    });
  }

  async signIn(email: string, password: string, rememberMe: boolean = false) {
    return await ky.post('v1/auth/sign-in', {
      searchParams: { rememberMe },
      json: { email, password },
    });
  }

  async signOut() {
    return await ky.post('v1/auth/sign-out');
  }

  /**
   * 회원가입을 완료합니다.
   *
   * 토큰에는 이메일 인증시 사용한 토큰을 사용합니다.
   *
   * @param token 토큰
   * @param email 이메일
   * @param password 비밀번호
   * @param termsAgreements 약관 동의 리스트(TermsDto의 id만 있으면 됨)
   */
  async signUp(token: string, email: string, password: string, termsAgreements: TermsAgreementDto[]) {
    return await ky.post('v1/auth/sign-up', {
      json: { email, password, token, termsAgreements },
    });
  }

  /**
   * email로 이메일 인증 요청을 전송합니다.
   *
   * 제공한 이메일로 6자리 숫자 인증 코드가 전송되며, 인증에 사용되는 토큰을 응답합니다.
   *
   * @param email 이메일
   * @return 이메일 인증 토큰
   */
  async sendEmailVerification(email: string) {
    return (await ky.post('v1/auth/sign-up/email/verification/send', {
      json: { email },
    }).json() as { token: string }).token;
  }

  /**
   * 이메일 인증을 합니다.
   *
   * @param token 이메일 인증 요청시 받은 토큰
   * @param code  이메일로 수신한 인증 코드
   */
  async emailVerification(token: string, code: string) {
    return await ky.post('v1/auth/sign-up/email/verification', {
      json: { token, code },
    });
  }
}

